import React from "react";
import { AppStartupLoaderTemplate } from "themes/common/components";

function AppStartupLoader() {
    return <AppStartupLoaderTemplate />;
}

export default AppStartupLoader;
